/**
 * Replaces [price] placeholders in announcement bar elements.
 * Elements must have a data-announcement-price attribute with cents value.
 * Runs before updateDynamicPrices so the created spans are available for currency updates.
 */
function updateAnnouncementBarPrices() {
  const els = document.querySelectorAll('[data-announcement-price]');
  if (!els.length) return;

  const rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1);
  const activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  const activeLocale = (window.Shopify && window.Shopify.locale) || 'en';

  const formatter = new Intl.NumberFormat(activeLocale, {
    style: 'currency',
    currency: activeCurrency,
  });

  els.forEach(el => {
    const cents = parseInt(el.getAttribute('data-announcement-price'), 10);
    if (isNaN(cents)) return;
    const formatted = formatter.format((cents * rate) / 100);
    el.innerHTML = el.innerHTML.replace(
      /\[price\]/g,
      `<span class="js-dynamic-price" data-price="${cents}">${formatted}</span>`
    );
  });
}

/**
 * Formats all elements with class 'js-dynamic-price' using Shopify's active currency.
 * The elements must have a 'data-price' attribute containing the price in cents.
 */
function updateDynamicPrices() {
  const elements = document.querySelectorAll('.js-dynamic-price');
  if (elements.length === 0) return;

  const rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1);
  const activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || window.Shopify?.currency?.iso_code || 'USD';
  const activeLocale = (window.Shopify && window.Shopify.locale) || 'en';

  const formatter = new Intl.NumberFormat(activeLocale, {
    style: 'currency',
    currency: activeCurrency,
  });

  elements.forEach(el => {
    const cents = parseInt(el.getAttribute('data-price'), 10);
    if (!isNaN(cents)) {
      el.textContent = formatter.format((cents * rate) / 100);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateAnnouncementBarPrices();
  updateDynamicPrices();
});

window.updateAnnouncementBarPrices = updateAnnouncementBarPrices;
window.updateDynamicPrices = updateDynamicPrices;
